import Entity from "./Entity";

export const allowedRefundAllocationTypes = [
  'FULL'
];

const refundEntityFieldsWithDynamicAllowedValues = {
  type: { enumName: 'RefundTypeEnum' }
}

export default class Refund {
  fields = {
    id: {
      value: null
    },
    payment_id: {
      value: null
    },
    type: {
      value: null
    },
    refund_meta: {
      value: null
    },
    amount: {
      value: null
    }
  }

  static createFromQueryValues(values) {
    let refund = new this();

    for (let field in refund.fields) {
      if (values.hasOwnProperty(field)) {
        switch (field) {
          case 'created_at':
            refund.fields[field].value = (values[field] === null) ?
              values[field] :
              new Date(Number(values[field]));
            break;
          default:
            refund.fields[field].value = values[field];
        }
      }
    }

    return refund;
  }

  static getFieldAllowedValues(fields) {
    return Entity.getFieldAllowedValues(
      {},
      refundEntityFieldsWithDynamicAllowedValues,
      fields
    );
  }

  static getRefundAllocationTypes() {
    return Entity.getFieldAllowedValues(
      {},
      { allocation: { enumName: 'RefundAllocationEnum' } },
      [ 'allocation' ]
    );
  }
}

export const RefundInput = {
  payment_id: null,
  allocation: null,
  entry_ids: null,
}